export default __webpack_public_path__ + "static/media/large_assessment_backkground.4edd751a.svg";